// start:ng42.barrel
import './record-payment-checkout.component';
import './record-payment-detail.component';
import './record-payment-filter.component';
import './record-payment.component';
// end:ng42.barrel

